export default __webpack_public_path__ + "static/media/host_btnWhite.ce318362.svg";